import axios from 'axios'
import axiosConfig from '@/config/config'
const qs = require('qs')

const instance = axios.create({
    withCredentials: true
})
instance.interceptors.request.use(config => {
    if (!/http/.test(config.url)) {
        config.url = `${axiosConfig.JAVA_SERVER}${config.url}`
    }
    if (config.method === 'get') {
        if (config.params === undefined) {
            config.params = {}
        }
    } else if (config.method === 'post') {
        config.data.appVer = '1.9.0'
        config.data.channelId = '3000001'
        config.data.platType = 3
        config.data = qs.stringify(config.data)
    }
    console.log(config)
    return config
}, error => {
    return Promise.reject(error)
})

instance.interceptors.response.use(function (response) {
    // console.log(response)
    let isStream = /(octet-stream|x-download)/.test(response.headers['content-type'])
    if (isStream) {
        return response.data
    }
    return response.data
}, function (error) {
    console.warn('net error', error.config && error.config.url)
    return Promise.reject(error)
})

export default instance



// WEBPACK FOOTER //
// ./src/query/ajax.js